<template>
  <div class="v-application--wrap">
    <the-layout-navigation v-if="navigationShow" :show-drawer="showDrawer" @toggle-nav-drawer="toggleNavDrawer" />
    <the-layout-toolbar @toggle-nav-drawer="toggleNavDrawer" />
    <the-layout-content />
    <the-layout-to-top-fab />
    <the-layout-footer />

    <!-- snackbar for notifications -->
    <snackbar></snackbar>

    <!-- alert for notifications -->
    <alert-floating></alert-floating>

    <!-- Attachments preview modal -->
    <AttachmentsPreview v-if="showPreview" :attachment="selectedAttachment" />

    <!-- confirmation modals -->
    <ConfirmModal />
  </div>
</template>

<script>

// components.
import AlertFloating from '@/views/modules/components/notifications/AlertFloating.vue';
import Snackbar from '@/views/modules/components/notifications/Snackbar.vue';
import TheLayoutFooter from '@/views/layout/TheLayoutFooter.vue';
import TheLayoutToolbar from '@/views/layout/TheLayoutToolbar.vue';
import TheLayoutContent from '@/views/layout/TheLayoutContent.vue';
import TheLayoutToTopFab from '@/views/layout/TheLayoutToTopFab.vue';
import AttachmentsPreview from '@/atoms/AttachmentsPreview.vue';
import TheLayoutNavigation from '@/views/layout/TheLayoutNavigation.vue';
import ConfirmModal from '../modules/components/dialogs/ConfirmModal.vue';

export default {
  name: 'TheLayout',
  components: {
    AlertFloating,
    Snackbar,
    ConfirmModal,
    TheLayoutFooter,
    TheLayoutToolbar,
    TheLayoutContent,
    TheLayoutToTopFab,
    AttachmentsPreview,
    TheLayoutNavigation,
  },
  data() {
    return {
      showDrawer: false,
      intervalRef: null,
    };
  },
  computed: {
    navigationShow() {
      let showCondition = true;
      if (this.isMobileDevice) {
        showCondition = this.showDrawer;
      }

      return showCondition;
    },
  },
  created() {
    // hack for breakpoints not triggered when changing orientation on iphone
    // TODO:: find a better way
    this.intervalRef = setInterval(() => {
      this.$vuetify.breakpoint.update();
    }, 400);
  },
  destroyed() {
    clearInterval(this.intervalRef);
  },
  methods: {
    toggleNavDrawer(val) {
      if (val) {
        this.$store.dispatch('NavbarState', { state: val });
        this.showDrawer = val;
      } else {
        this.showDrawer = !this.showDrawer;
        this.$store.dispatch('NavbarState', { state: this.showDrawer });
      }
    },
  },
};
</script>

<style>
.v-application--wrap {
  min-height: 100dvh;
}
</style>
